import React from "react";

const HARASSMENT_PREVENTION_URL =
	"https://www.lyzon.co.jp/utility/harassment_prevention/";

const FooterView = (props) => (
	<footer className={props.footerClass}>
		<div className="footer-wrap">
			<p className="footer-corporateLink">
				<a
					className="external"
					href="https://www.lyzon.co.jp/"
					target="_blank"
					rel="noopener noreferrer"
				>
					LYZONコーポレートサイトへ
				</a>
				<a
					className="external"
					href={HARASSMENT_PREVENTION_URL}
					target="_blank"
					rel="noopener noreferrer"
				>
					求職活動を行うみなさまへ
				</a>
			</p>
			<small>© LYZON Inc.</small>
		</div>
	</footer>
);

export default class footerClass extends React.PureComponent {
	render() {
		let footerClassName = this.props.isModalFooter
			? "l-footer modal-footer"
			: "l-footer";

		return <FooterView footerClass={footerClassName} />;
	}
}



// WEBPACK FOOTER //
// ./src/Home/Footer.js